/**
 * Line / Area series style overrides.
 *
 * Applies line style (smooth, step, regular), line width, markers,
 * area opacity, and stacking.
 */
import type { TypeStyle } from '../../../../../edit/visualConfig';

export function applyLineOverrides(series: any, cs: TypeStyle): any {
  const patched = { ...series };
  const ls = cs.lineStyle ?? 'regular';

  if (ls === 'smooth') patched.smooth = true;
  if (ls === 'step') patched.step = 'middle';

  if (cs.lineWidth != null) {
    patched.lineStyle = { ...patched.lineStyle, width: cs.lineWidth };
  }

  // Markers (data point dots)
  if (cs.showMarkers === false) {
    patched.showSymbol = false;
  } else if (cs.markerSize != null) {
    patched.symbolSize = cs.markerSize;
    patched.showSymbol = true;
  }

  // Area fill opacity
  if (patched.areaStyle) {
    patched.areaStyle = { ...patched.areaStyle, opacity: cs.areaOpacity ?? 0.12 };
  }

  // Stacking
  if (cs.stacking === 'normal' || cs.stacking === 'percent') {
    patched.stack = 'total';
  }

  return patched;
}